import SPage from '@/utils/classes/SPage';
import { i18n } from '@/plugins/i18n';
import {
  editMedium,
  eyeBold,
  hourglass,
  microphone,
  navigation,
} from '@/assets/icons';

export const ROLES = [
  {
    id: 1,
    titleTr: 'message.ROLE_LEADER',
    definitionTr: 'message.ROLE_LEADER_DEF',
    src: microphone,
    color: '#22384C',
    assigned: false,
  },
  {
    id: 2,
    titleTr: 'message.ROLE_TIME_KEEPER',
    definitionTr: 'message.ROLE_TIME_KEEPER_DEF',
    src: hourglass,
    color: '#2A5A91',
    assigned: false,
  },
  {
    id: 3,
    titleTr: 'message.ROLE_CARE_TAKER',
    definitionTr: 'message.ROLE_CARE_TAKER_DEF',
    src: eyeBold,
    color: '#1B75BB',
    assigned: false,
  },
  {
    id: 4,
    titleTr: 'message.ROLE_DECISION_LEADER',
    definitionTr: 'message.ROLE_DECISION_LEADER_DEF',
    src: editMedium,
    color: '#00ADEE',
    assigned: false,
  },
  {
    id: 5,
    titleTr: 'message.ROLE_FOCUS_KEEPER',
    definitionTr: 'message.ROLE_FOCUS_KEEPER_DEF',
    src: navigation,
    color: '#F15C61',
    assigned: false,
  },
];

/**
 * Event info types and repetition
 */
export const EventInfo = {
  type: {
    daily: 0,
    weekly: 1,
    monthly: 2,
    custom: 3,
  },
};

/** Available rating in meeting-rating page */
export const ratings = [
  { rating: 1, status: 'angry', textTr: 'message.UNACCEPTABLE', color: '#f13122' },
  { rating: 2, status: 'sad', textTr: 'message.BAD', color: '#dab42a' },
  { rating: 3, status: 'good', textTr: 'message.ACCEPTABLE', color: '#b1b439' },
  { rating: 4, status: 'happy', textTr: 'message.GOOD', color: '#36b24a' },
];

// WARNING: Data below should match data in meeting/func.php
export const DEFAULT_REPEAT_DATA = [
  [
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
    { on: false, time: '08:00' },
  ],
  { day: 0, time: '08:00' },
  { day: 1, time: '08:00' },
  { day: null, time: '08:00' },
];

export const REPEAT_TYPE = {
  daily: 0,
  weekly: 1,
  monthly: 2,
  once: 3,
};

/**
 * Get all Shizen available pages in a page picker
 * @param  {Boolean} [noManagement=false] Exclude management pages
 * @param  {Boolean} [noMeeting=false]    Exclude meeting pages
 * @param  {Boolean} [noGembaWalk=false]  Exclude gembaWalk pages
 * @param  {Boolean} [noSettings=false]   Exclude settings pages
 * @return {Array}                        Array to pass as a value for an EditableLabelRadio
 */
export function getAllPageLinks(noManagement = false, noMeeting = false, noGembaWalk = false, noSettings = false) {
  const categories = [];
  if (!noMeeting) {
    categories.push(SPage.categories.meetings);
  }
  categories.push(SPage.categories.main);
  if (!noManagement) {
    categories.push(SPage.categories.management);
  }
  if (!noGembaWalk) {
    categories.push(SPage.categories.gembaWalk);
  }
  if (!noSettings) {
    categories.push(SPage.categories.settings);
  }
  return categories.map((category) => {
    const pages = category.pages
      .filter(page => !page.deprecated && !page.excludeFromPagePicker)
      .map(page => ({ ...page, title: i18n.t(page.i18nName) }));
    return { title: i18n.t(category.i18nName), radioItems: pages };
  });
}

export default {
  ROLES,
  EventInfo,
  ratings,
  DEFAULT_REPEAT_DATA,
  REPEAT_TYPE,
  getAllPageLinks,
};
